var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIconSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19.9991C1.34315 19.9991 0 18.6559 0 16.9991V9.33516C0 8.4847 0.360964 7.6742 0.993106 7.10527L7.9931 0.805274C9.13402 -0.221549 10.866 -0.22155 12.0069 0.805273L19.0069 7.10527C19.639 7.6742 20 8.4847 20 9.33516V16.9991C20 18.6559 18.6569 19.9991 17 19.9991H3ZM18 9.33516V16.9991C18 17.5514 17.5523 17.9991 17 17.9991H14V12.9991C14 11.3422 12.6569 9.99907 11 9.99907H9C7.34315 9.99907 6 11.3422 6 12.9991V17.9991H3C2.44772 17.9991 2 17.5514 2 16.9991V9.33516C2 9.05167 2.12032 8.7815 2.33104 8.59186L9.33103 2.29186C9.71134 1.94959 10.2887 1.94959 10.669 2.29186L17.669 8.59186C17.8797 8.7815 18 9.05167 18 9.33516ZM8 17.9991V12.9991C8 12.4468 8.44772 11.9991 9 11.9991H11C11.5523 11.9991 12 12.4468 12 12.9991V17.9991H8Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconSidebar);
export default __webpack_public_path__ + "static/media/dashboardIconSidebar.fea5fe20ef61c618dfb7811d974e203d.svg";
export { ForwardRef as ReactComponent };